import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import "./pd-mail-item.js";
import { LitElement, css, html } from "lit";
import { property } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import { repeat } from "lit/directives/repeat.js";
//#region src/pd-mail/PdMailList.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
var PdMailList = class PdMailList extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.entries = [];
		this.loading = false;
		this.withResend = false;
	}
	static {
		this.styles = css`
    :host {
      display: block;
      container-type: inline-size;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      padding: var(--pd-mail-row-gap, 0) 0;
    }

    li + li {
      border-top: 1px solid
        var(--pd-mail-separator-col, var(--pd-default-light-col, #e0e0e0));
    }

    .empty {
      color: var(--pd-default-font-muted-col, #757575);
      font-style: italic;
      padding: 0.6rem 0;
    }

    .skeleton {
      height: 3rem;
      margin: 0.6rem 0;
      border-radius: 4px;
      background: var(--pd-default-bg-light-col, #eee);
      animation: pulse 1.5s ease-in-out infinite;
    }

    @keyframes pulse {
      50% {
        opacity: 0.5;
      }
    }
  `;
	}
	render() {
		return html`
      <div class="head"><slot name="head"></slot></div>
      ${this.loading ? this._renderLoading() : this._renderList()}
      <div class="footer"><slot name="footer"></slot></div>
    `;
	}
	/**
	* Filter hook for the upcoming search/state-filter extension —
	* the render list always runs through this step.
	*/
	get _visibleEntries() {
		return this.entries;
	}
	_renderLoading() {
		return html`
      <div
        role="status"
        aria-label="${msg("Mails werden geladen", { id: "pd.mail.list.loading" })}"
      >
        <div class="skeleton"></div>
        <div class="skeleton"></div>
        <div class="skeleton"></div>
      </div>
    `;
	}
	_renderList() {
		const entries = this._visibleEntries;
		if (entries.length === 0) return html`
        <div class="empty">
          ${this.emptyText ?? msg("Keine Mails vorhanden", { id: "pd.mail.list.empty" })}
        </div>
      `;
		return html`
      <ul role="list">
        ${repeat(entries, (entry) => entry.id, (entry) => html`
            <li>
              <pd-mail-item
                .entry="${entry}"
                .templateLabels="${this.templateLabels}"
                .fieldLabels="${this.fieldLabels}"
                .extraLabels="${this.extraLabels}"
                ?withResend="${this.withResend}"
              ></pd-mail-item>
            </li>
          `)}
      </ul>
    `;
	}
};
__decorate([property({ attribute: false })], PdMailList.prototype, "entries", void 0);
__decorate([property({ type: Boolean })], PdMailList.prototype, "loading", void 0);
__decorate([property({ attribute: false })], PdMailList.prototype, "templateLabels", void 0);
__decorate([property({ attribute: false })], PdMailList.prototype, "fieldLabels", void 0);
__decorate([property({ attribute: false })], PdMailList.prototype, "extraLabels", void 0);
__decorate([property({ type: Boolean })], PdMailList.prototype, "withResend", void 0);
__decorate([property()], PdMailList.prototype, "emptyText", void 0);
PdMailList = __decorate([localized()], PdMailList);
//#endregion
export { PdMailList };
